import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "kpi-setting" }
const _hoisted_2 = { class: "kpi-setting__header" }
const _hoisted_3 = { class: "kpi-setting__header__title" }
const _hoisted_4 = { class: "kpi-setting__header__desc" }
const _hoisted_5 = { class: "kpi-setting__setting" }
const _hoisted_6 = { class: "kpi-setting__setting__row kpi-setting__setting__row--border" }
const _hoisted_7 = { class: "kpi-setting__button" }

import { i18n } from '@/i18n';
import { computed, onMounted, ref } from 'vue';
import InventoryDashboardChildLayout from './InventoryDashboardChildLayout.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { useRouter } from 'vue-router';
import { INVENTORY_DASHBOARD_PATH } from '../constants';
import { Kpi } from '../domains/entities/Kpi';
import { storeToRefs } from 'pinia';
import { useInventoryDashboardStore } from './useInventoryDashboardStore';
import { showInfoModal } from '@/corePagesModule/components/InfoModal/InfoModalManager';
import { UserAccount } from '@/coreDomainsModule/entities/users';
import DecimalNumberInput from '@/corePagesModule/components/DecimalNumberInput.vue';
import { KpiFactory } from '../domains/factories/KpiFactory';
import { DimensionTypes, MetricTypes } from '../domains/entities/Dashboard';
import { UNASSIGNED_COLUMN } from '@/coreDomainsModule/constants';
import { waitLoading } from '@/corePagesModule/components/InfoModal/waitLoading';


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingKpiPage',
  setup(__props) {

const t = i18n.t;
const router = useRouter();

const store = useInventoryDashboardStore();
const { getKpiData, getAggregateBusinessResponsibleUsersForKpi, postKpiData } = store;

const kpiData = ref<Kpi[]>([]);
const userData = ref<UserAccount[]>([]);

const kpiWithUser = computed((): Array<UserAccount & { kpi: Kpi | undefined }> => {
  console.log(userData.value);
  return userData.value.map((u) => {
    return {
      ...u,
      kpi: kpiData.value.find((k) => k.dimensions[0].dimensionValue.code === u.email && k.dimensions[0].dimensionValue.name === u.name),
    };
  });
});

/**
 * KPI入力値をユーザー単位で更新する
 * @param value - 入力されたKPI値
 * @param index - 対象ユーザーの行インデックス
 */
const inputKpiHander = (value: number, index: number) => {
  const target = kpiWithUser.value[index];
  if (target.kpi) {
    const targetKpiData = kpiData.value.find(
      (k) => k.dimensions[0].dimensionValue.code === target.email && k.dimensions[0].dimensionValue.name === target.name
    );
    if (!targetKpiData) return;
    targetKpiData.kpiValue = value;
  } else {
    kpiData.value.push(
      KpiFactory.create({
        metricType: MetricTypes.Turnover,
        kpiValue: value,
        dimensions: [
          {
            dimensionType: DimensionTypes.AggregateBusinessResponsibleUser,
            dimensionValue: {
              code: target.email,
              name: target.name,
            },
          },
        ],
      })
    );
  }
};

/**
 * 戻るボタンを押下時ハンドラ
 */
const handleOnClickBack = () => {
  router.push(INVENTORY_DASHBOARD_PATH);
};

/**
 * 確定ボタン押下時ハンドラ
 */
const handleOnClickSave = async () => {
  const res = await postKpiData(kpiData.value);
  if (res) {
    router.push(INVENTORY_DASHBOARD_PATH);
  } else {
    await showInfoModal({
      modalTitle: t('KPI保存時にエラーが発生しました。'),
      modalDescription: t('リロードして再度お試しください。'),
      backButtonLabel: t('OK'),
      isDisabledNextButton: true,
    });
    return;
  }
};

onMounted(async () => {
  const [resKpiData, resUserData] =
    (await waitLoading(Promise.all([getKpiData(), getAggregateBusinessResponsibleUsersForKpi()]), undefined, '')) ?? [];
  if (resKpiData == null || resUserData == null) {
    await showInfoModal({
      modalTitle: t('KPI取得時にエラーが発生しました。'),
      modalDescription: t('リロードして再度お試しください。'),
      backButtonLabel: t('OK'),
      isDisabledNextButton: true,
    });
    return;
  }
  kpiData.value = resKpiData;
  userData.value = resUserData;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InventoryDashboardChildLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('仕入担当者の在庫回転率KPIの設定')), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('担当者ごとに目標とする在庫回転率（ヶ月）を記入してください')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, _toDisplayString(_unref(t)('仕入担当者')), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(t)('在庫回転率')), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kpiWithUser.value, (value, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "kpi-setting__setting__row"
            }, [
              _createElementVNode("div", null, _toDisplayString(value.name || _unref(t)(_unref(UNASSIGNED_COLUMN))), 1),
              _createElementVNode("div", null, [
                _createVNode(DecimalNumberInput, {
                  "model-value": value.kpi?.kpiValue,
                  placeholder: _unref(t)('例: 1.2'),
                  "onUpdate:modelValue": (e) => inputKpiHander(e, index)
                }, null, 8, ["model-value", "placeholder", "onUpdate:modelValue"])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(TextButton, {
            "button-style": "btn-secondary",
            onClick: handleOnClickBack
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('戻る')), 1)
            ], undefined, true),
            _: 1
          }),
          _createVNode(TextButton, {
            "button-style": "btn-primary",
            onClick: handleOnClickSave
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('保存')), 1)
            ], undefined, true),
            _: 1
          })
        ])
      ])
    ], undefined, true),
    _: 1
  }))
}
}

})